import { ReactNode } from 'react';
import { Button, Card, Skeleton, Stack, Text } from '@mantine/core';

type LibraryTabPanelProps = {
  tabLabel: string;
  isLoading: boolean;
  isError: boolean;
  onRetry: () => void;
  isEmpty: boolean;
  emptyTitle: string;
  emptyBody: string;
  children: ReactNode;
};

export default function LibraryTabPanel({
  tabLabel,
  isLoading,
  isError,
  onRetry,
  isEmpty,
  emptyTitle,
  emptyBody,
  children,
}: LibraryTabPanelProps) {
  if (isLoading) {
    return (
      <Stack gap="sm">
        {[0, 1, 2].map(row => (
          <Skeleton key={row} height={92} radius="md" />
        ))}
      </Stack>
    );
  }

  if (isError) {
    return (
      <Card withBorder padding="xl" radius="md">
        <Stack gap="xs" align="center">
          <Text fw={600} role="alert">{`Couldn't load the ${tabLabel}`}</Text>
          <Text size="sm" c="dimmed" ta="center" maw={470}>
            Something went wrong at our end.
          </Text>
          <Button variant="default" onClick={onRetry} mt="xs">
            Try again
          </Button>
        </Stack>
      </Card>
    );
  }

  if (isEmpty) {
    return (
      <Card withBorder padding="xl" radius="md">
        <Stack gap="xs" align="center">
          <Text fw={600}>{emptyTitle}</Text>
          <Text size="sm" c="dimmed" ta="center" maw={470}>
            {emptyBody}
          </Text>
        </Stack>
      </Card>
    );
  }

  return <Stack gap="sm">{children}</Stack>;
}
